import React from 'react';
import locales from '../../locales/LocalesManager';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';

const NoInternetConnectionAlertContent = React.createClass({
    isVisible() {
        if (this.props.showLostSessionAlert == 5)
            return true;
        else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.showLostSessionAlert != newProps.showLostSessionAlert || this.props.windowHeight != newProps.windowHeight || this.props.windowWidth != newProps.windowWidth)
            return true;
        else
            return false;
    },
    render() {
        var visible = 'none';

        if (this.isVisible())
            visible = 'block';
        else
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            background: '#e9ff48',
            top: 0,
            left: 0,
            display: visible,
            userSelect: 'none',
            cursor: 'default',
            fontSize: 16,
            fontStyle: 'italic',
            textAlign: 'center',
            color: 'black',
            zIndex: 20000
        };

        var iStyle = {
            color: 'black',
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 10
        };

        return (
            <div style={menuStyle}>
                <i style={iStyle} className="fa fa-exclamation-triangle fa-1x"></i>
                    {locales.getCaption('InternetConnectionAlert', 'other')}
                <i style={iStyle} className="fa fa-exclamation-triangle fa-1x"></i>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showLostSessionAlert = state.menu.showLostSessionAlert;

    return {
        showLostSessionAlert
    };
}

export const NoInternetConnectionAlert = connect(mapStateToProps)(NoInternetConnectionAlertContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/NoInternetConnectionAlert.js
 **/